import { useFlag } from '@/features/unleash';
import { cn } from '@simplywallst/ui-core/next';
import { ComponentProps, ReactNode } from 'react';

type Props = {
  children: ReactNode;
} & ComponentProps<'section'>;

export const NarrativeCommunityListLayout = ({
  children,
  className,
  ...rest
}: Props) => {
  const miniValuatorFlag = useFlag({
    name: 'mono-narrative-mini-valuator-hub',
  });
  const isMiniValuatorEnabled =
    miniValuatorFlag.enabled && miniValuatorFlag.flagsReady;

  return (
    <section
      className={cn(
        'grid grid-cols-1 gap-x2 @6xl/main:grid-cols-2',
        !isMiniValuatorEnabled && 'lg:grid-cols-3',
        className
      )}
      {...rest}
    >
      {children}
    </section>
  );
};
